import React from 'react';
import { Link } from '@tanstack/react-router';
import menuTheme from 'styles/theme_menu';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { Divider, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { AccountCircle, Description, ExitToApp, Home, Person, Pets, SettingsApplications } from '@mui/icons-material';
import { actions } from "store";
import { useDispatch } from "react-redux";
import { NavigationRoot, LinkStyle } from './Navigation.styles';



const Navigation = () => {
	const dispatch           = useDispatch(),
		  menuOpenTemporary  = () => dispatch(actions.layout.menuOpenTemporary()),
		  menuCloseTemporary = () => dispatch(actions.layout.menuCloseTemporary());

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={menuTheme}>
				<NavigationRoot onMouseEnter={menuOpenTemporary} onMouseLeave={menuCloseTemporary}>
					<List>
						<ListItem component={Link} to="/" sx={LinkStyle}>
							<ListItemIcon><Home style={{ color: '#a7a6ff' }} /></ListItemIcon>
							<ListItemText primary={'Home'} />
						</ListItem>

						<ListItem component={Link} to="/clients" sx={LinkStyle}>
							<ListItemIcon><Person style={{ color: '#68cbff' }} /></ListItemIcon>
							<ListItemText primary={'Clients'} />
						</ListItem>

						<ListItem component={Link} to="/patients" sx={LinkStyle}>
							<ListItemIcon><Pets style={{ color: '#83ff6b' }} /></ListItemIcon>
							<ListItemText primary={'Patients'} />
						</ListItem>

						<ListItem component={Link} to="/reports" sx={LinkStyle}>
							<ListItemIcon><Description style={{ color: '#ffeb37' }} /></ListItemIcon>
							<ListItemText primary={'Reports'} />
						</ListItem>


						<Divider />


						<ListItem component={Link} to="/my-account" sx={LinkStyle}>
							<ListItemIcon><AccountCircle /></ListItemIcon>
							<ListItemText primary={'My Account'} />
						</ListItem>

						<ListItem component={Link} to="/clinic-settings" sx={LinkStyle}>
							<ListItemIcon>
								<SettingsApplications style={{ color: '#ffa749' }} />
							</ListItemIcon>
							<ListItemText primary="Clinic Settings" />
						</ListItem>

						<ListItem component={Link} to="/test" sx={LinkStyle}>
							<ListItemIcon>
								<SettingsApplications style={{ color: '#ffa749' }} />
							</ListItemIcon>
							<ListItemText primary="Test Page" />
						</ListItem>

						<Divider />

						<ListItem component={Link} to="/logout" sx={LinkStyle}>
							<ListItemIcon>
								<ExitToApp style={{ color: '#ff7070' }} />
							</ListItemIcon>
							<ListItemText primary="Log out" style={{ color: '#e0e0e0' }} />
						</ListItem>

						{/*
                            <ListItem button onClick={setRoute('/_symboltest')}>
                                <ListItemIcon><ExitToApp style={{ color: '#ffffff' }} /></ListItemIcon>
                                <ListItemText primary={'Symbol Test'} />
                            </ListItem>
                        */}
					</List>
				</NavigationRoot>
			</ThemeProvider>
		</StyledEngineProvider>
	);

};



export default Navigation;
